<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.vehicle_selection.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-text-field
          :label="$t('dialog.vehicle_selection.filter')"
          v-model="vehicleFilter"
          autofocus
          solo
          flat
          hide-details
          prepend-inner-icon="mdi-filter"
          style="width: 40px"
        ></v-text-field>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-virtual-scroll ref="vscroll" :items="filteredVehicles" bench="1064" min-height="104px" max-height="50vh"
                        item-height="54">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.vehicleId" @click="vehicleSelect(item)">
            <v-list-item-content>
              <v-list-item-title><b>{{ item.numericPlate }}</b>&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "CompanyVehicleSelectionDialog",

  data() {
    return {
      dialog: false,
      vehicleFilter: null,

      vehicles: []
    };
  },

  methods: {
    open() {
      this.vehicleFilter = null;
      this.dialog = true;

      this.$nextTick().then(() => {
        this.$refs.vscroll.$el.scrollTop = 1;
        this.$refs.vscroll.$el.scrollTop = 0;
      });
    },

    vehicleSelect(item) {
      this.$emit("selected", item);
      this.dialog = false;
    },

    keyEvent(keyEvent) {
      if (!this.dialog)
        return;

      if (keyEvent.key === "Enter") {
        const list = this.filteredVehicles;

        if (list.length === 1)
          this.vehicleSelect(list[0]);
      }
    }
  },

  watch: {
    dialog(newValue) {
      if (newValue === false)
        ;
    }
  },

  computed: {
    filteredVehicles() {
      if (this.vehicleFilter != null)
        return this.vehicles.filter(
          x => x.numericPlate.toLowerCase().includes(this.vehicleFilter.toLowerCase()));
      else
        return this.vehicles;
    }
  },

  mounted() {
    document.addEventListener("keydown", this.keyEvent);

    this.$store.dispatch("data/fetchVehicles", false)
      .then(result => {
        this.vehicles = result.data;
      });

  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyEvent);
  }
};
</script>